import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { getCustomEvent } from '../../core/utils/http-request-utils';
import { LoadingAction } from '../models/loading-action.enum';
import { AuthStoreService } from './auth/auth-store.service';

@Injectable({
  providedIn: 'root',
})
export class PhoneNumberVerificationApiService {
  private NAMESPACE = 'phone_verification';

  constructor(private api: ApiService, private auth: AuthStoreService) {}

  public phoneNumberVerification(phoneNumber: number): Observable<any> {
    const param = getCustomEvent(LoadingAction.PHONE_VERIFICATION, this.NAMESPACE, this.auth.customerId);
    return this.api.post(`/customers/${this.auth.customerId}/phone-number-verification`, {
      phoneNumber,
    }, { params: param });
  }

  public phoneNumberUsage(phoneNumber: number): Observable<any> {
    return this.api.get(`/customers/${this.auth.customerId}/phone-number-usage`, {
      phoneNumber: String(phoneNumber),
    });
  }
}
